import { render, staticRenderFns } from "./PersonalBlog.vue?vue&type=template&id=099568e4&"
import script from "./PersonalBlog.vue?vue&type=script&lang=js&"
export * from "./PersonalBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports